<template>
  <main class="flex bg-white new-shadow-theme br3  custom-padding responsive-box">
    <div class="flex flex-column w-100 responsive-plan">
      <img class="image-bot" src="/static/upsell/upsellConfirm.png" alt="" />
      <div class="mt4 flex flex-column justify-center items-center cera-round-pro-medium">
        <div class="w-50-l w-100 tc ph4 ph0-l">
          <div class="f4 mb2">Add-ons Successfully Added!</div>
          <div class="gray-text inter f6">Congrats! The add-on plan has been successfully added to your account. You will soon receive an email with instructions on setting up your coverage</div>
        </div>
      </div>
      <div class="flex justify-center mt4">
        <ak-button
          class="button-responsive "
          newPrimary
          @click.native="finishUpsell(true)"
        >
          Continue
        </ak-button>
      </div>
    </div>
  </main>
</template>

<script>
import AkButton from '@/components/Button'

export default {
  name: 'confirm-upsell',
  components: {
    AkButton
  },
  props: {
    finishUpsell: Function
  }
}
</script>

<style scoped>

.container {
  border: 1px solid #e6e6e6;
}

.gray-text {
  color: var(--theme-dark-gray-text)
}

.button-responsive {
  width: 35%
}
.red-tick {
  position: absolute;
  right: 5px;
  top: 15px;
}
.w-45 {
  width: 45%;
}

.custom-width {
  max-width: 850px;
  width: max-content;
}

.gray-normal-text {
  color: var(--theme-gray-text)
}
.gray-text {
  color: var(--theme-dark-gray-text)
}

.custom-padding {
  padding: 2.7em 0% 2.7em 0%;
}

@media (max-width: 1280px) {
  .responsive-box {
    width: 80%;
    margin: 1em 0;
  }
}



@media (max-width: 600px) {
  .responsive-box {
    width: 100%;
    margin: 1em 0;
  }

  .custom-padding {
    padding: 0;
    background-color: transparent;
    box-shadow: none;
  }
  .responsive-plan {
    border: 1px solid var(--theme-medium-gray);
    padding: 1.5em 0em;
    border-radius: 0.5em;
    background-color: white;
  }

}
</style>



// WEBPACK FOOTER //
// ConfirmUpsell.vue?598abf38